import graphql__cd036c38e5eafac3aa3f from "./__generated__/PauseOralInterviewMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__cd036c38e5eafac3aa3f;

const pauseOralInterview = (
  variables,
  onCompleted,
  onError = error => console.error(error)
) =>
  commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError
  });

export { pauseOralInterview };
